import React from 'react';

export default function Pie(props) {
    return (
        <svg
            width="48px"
            height="48px"
            viewBox="0 0 48 48"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            {/* Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch */}
            <title>100</title>
            <desc />
            <g
                id="Icon-/-Session-Summary-/-Block-/-100"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <path
                    d={props.path}
                    id="Shape"
                    fill="#00BD76"
                    fillRule="nonzero"
                    className={props.className}
                />
            </g>
        </svg>
    );
}
